import * as React from 'react'

import ThumbnailAndLabelWrapper from '~/molecules/listItem/ThumbnailAndLabelWrapper'
import PersonIcon from '~/atoms/icon/PersonIcon'
import {
  formatDatetimeDurationLong,
  formatDatetimeDurationShort,
} from '@/utils/dateFormat'
import * as Style from './style.css'

interface IProps {
  reserves: IReserveSummary[]
}

const requestTypeName = (reserve: IReserveSummary): string => {
  if (reserve.interview_flg) {
    return `${reserve.request_type_i18n}(事前面談)`
  } else if (reserve.casual_interview_flag) {
    return `${reserve.request_type_i18n}(顔合わせ)`
  }
  return reserve.request_type_i18n
}

const getSupporterName = (reserve: IReserveSummary): string => {
  if (reserve.user) {
    return `${reserve.user.display_name}`
  }
  return ''
}

const isHousekeeping = (reserve: IReserveSummary): boolean =>
  reserve.request_type === 'request_housekeeping'

const getStatusColor = (
  reserve: IReserveSummary,
): 'highlight' | 'notice' | 'warning' | undefined => {
  if (reserve.need_response_account_type === 'account_parent') {
    return 'highlight'
  } else if (reserve.status === 'plan_price_confirmed') {
    return 'notice'
  } else if (
    reserve.need_response_account_type !== 'account_parent' &&
    reserve.status !== 'plan_price_confirmed' &&
    !reserve.end_status
  ) {
    return 'warning'
  }
  return undefined
}

const getUserThumbnailUrl = (user?: IUser): string => {
  if (!!user) {
    return user.image.middle_thumb.url
  }
  return '/img/dev/user56.png'
}

export const ParentReserveList = (props: IProps): JSX.Element => (
  <div className={Style.ParentReserveList}>
    {props.reserves.map((reserve) => {
      return (
        <a
          href={`/reserves/${reserve.slug}/detail`}
          key={reserve.slug}
          className={Style.ParentReserveListItem}
        >
          <div className={Style.ParentReserveListItemContent}>
            <ThumbnailAndLabelWrapper
              thumbnailUrl={getUserThumbnailUrl(reserve.user)}
              label={reserve.status_name_for_parent}
              labelColor={getStatusColor(reserve)}
            >
              <div className={Style.ParentReserveListItemLabelPC}>
                {formatDatetimeDurationLong(
                  reserve.valid_start_at,
                  reserve.valid_end_at,
                )}
              </div>
              <div className={Style.ParentReserveListItemLabelSP}>
                {formatDatetimeDurationShort(
                  reserve.valid_start_at,
                  reserve.valid_end_at,
                )}
              </div>
              <div className={Style.ParentReserveListItemLabel}>
                {requestTypeName(reserve)}
              </div>
              <div className={Style.ParentReserveListItemName}>
                {getSupporterName(reserve)}
              </div>
              <div>
                {!isHousekeeping(reserve) && (
                  <>
                    <div className={Style.ParentReserveListItemIcon}>
                      <PersonIcon />
                    </div>
                    <div className={Style.ParentReserveListItemIconLabel}>
                      {reserve.children_count}人
                    </div>
                  </>
                )}
              </div>
            </ThumbnailAndLabelWrapper>
          </div>
        </a>
      )
    })}
  </div>
)

export default ParentReserveList
